import { Form as FForm, Formik, FormikConfig } from 'formik';
import React, { FC } from 'react';
import { Card, Form } from 'react-bootstrap';

import FormFilterHeader from './form-filter-header';

type Props<T = { readonly [key: string]: any }> = FormikConfig<T> & {
  readonly title: string;
  readonly onClear?: any;
  readonly noHeader?: boolean;
};

const FormFilterCard: FC<Props> = ({
  onClear,
  title,
  children = null,
  noHeader = false,
  ...rest
}) => {
  return (
    <Card bg="light" className="form-filtered-card">
      <Formik {...rest}>
        {(formikProps) => (
          <Form as={FForm}>
            {!noHeader && <FormFilterHeader onClear={onClear} title={title} />}
            <Card.Body
              style={{ paddingTop: '0.6rem', paddingBottom: '0.15rem' }}
            >
              {typeof children === 'function'
                ? children(formikProps)
                : children}
            </Card.Body>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default FormFilterCard;
